export class ModelDeleteEvent {
  id: any;
  xferId?: string;
  reason: string = null;
  adaptData: any = null;
  //used if reason required by main thread
  constructor(id: any) {
    this.id = id;
  }
}
